<div [formGroup]="reportGenerationForm" *ngIf="reportGenerationForm != null">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="timeframe">Timeframe</label>
        <select class="form-control" id="timeframe" formControlName="timeframe">
          <option [value]="null" disabled>Select Report Type</option>
          <option *ngFor="let opt of timeframeOptions" [value]="opt.value">{{ opt.name }}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="startDate">Begin Date</label>
        <div class="input-group">
          <input
            id="startDate"
            type="text"
            class="form-control datepicker"
            formControlName="startDate"
            ngbDatepicker
            #s="ngbDatepicker"
            [firstDayOfWeek]="7"
            [placement]="['bottom-end', 'top-end']" />
          <img src="assets/icons/calendar.svg" (click)="s.toggle()" class="icon-append" />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="endDate">End Date</label>
        <div class="input-group">
          <input
            id="endDate"
            type="text"
            class="form-control datepicker"
            formControlName="endDate"
            ngbDatepicker
            #endDate="ngbDatepicker"
            [firstDayOfWeek]="7"
            [placement]="['bottom-end', 'top-end']" />
          <img src="assets/icons/calendar.svg" (click)="endDate.toggle()" class="icon-append" />
        </div>
      </div>
    </div>
  </div>
  <div
    class="row"
    *ngIf="reportGenerationForm.errors?.['invalidDateRange'] && reportGenerationForm.touched">
    <div class="col-12">
      <p class="error-text">Begin date should be before End date</p>
    </div>
  </div>

  <lib-report-buttons
    [disabled]="reportGenerationForm.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
